import React from "react";
import { useEffect,useState } from 'react';
import { Container, Button, Col, Row, Nav, NavDropdown } from "react-bootstrap";
import { Pen, PencilSquare, Person, PersonAdd, Plus, Search, Star, StarFill, Trash } from "react-bootstrap-icons";
import Accordion from 'react-bootstrap/Accordion';
import { FaUserCircle, FaEdit } from "react-icons/fa";
import './style.css';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import { SlArrowRight,SlMenu , SlUser, SlUserFollow} from "react-icons/sl";
import { FaUserLarge } from "react-icons/fa6";
import { BsBoxArrowRight } from "react-icons/bs";
import { AdUnits, Close, NewReleases, OpenInNew, ViewAgenda } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import baseUrl from "../../../../services/api";
import axios from "axios";
import SideBar from "../Componet/Sidebar";
import SplitButton from 'react-bootstrap/SplitButton';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { CDBCard, CDBCardBody,  CDBBtn, CDBContainer } from "cdbreact";
import { BiFilter } from "react-icons/bi";
import Moment from 'moment';
import { Rings } from "react-loader-spinner";
import {Helmet} from "react-helmet";

const FormHome = () =>{
  const session_username = sessionStorage.getItem("name");
  const session_email = sessionStorage.getItem("email");
  const session_role = sessionStorage.getItem("role");
  const session_token = sessionStorage.getItem("token");
  const [message, setMessage] = useState();
  const [compname, setComName] = useState();
  const [companyid, setCompanyId] = useState();
  const com_id = sessionStorage.getItem("com_id");
  const [formdata , setFormData] = useState(null);
  const [sortedData, setSortedData] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [formtype, setFormtype] = useState();
const navigate = useNavigate();


const [editsort, setEditSort] = useState(false);


function logout() {
  sessionStorage.clear();
  navigate("/login");
}

useEffect(() => {
  var item_value = sessionStorage.getItem("login");

  axios.defaults.headers.common = {
    Authorization: `Bearer ${session_token}`,
  };


 
  if (item_value != "1" ) {
    navigate("/login");
  }
  if( session_role != "user"){
    navigate("/login");
  }

  axios
  .get(`${baseUrl}/getAllSample`)
  .then((value) => {
    console.log("Form Data", value.data);
    setFormData(value?.data);
    setCompanyId(value.data[0]?.companyid);
  })
  .catch((reason) => {
    console.log("reason", reason.response.data);
    if (reason.response.data.includes("Token")) {
      navigate("/login");
    }
  });

  axios
  .get(`${baseUrl}/company/${companyid}`)
  .then((value) => {
    console.log("companyyyyyyy ", value);
    
  })
  .catch((reason) => {
    console.log("reason", reason.response.data);
    if (reason.response.data.includes("Token")) {
      navigate("/login");
    }
  });

  console.log('coming session id', com_id);
  axios
.get(`${baseUrl}/company/${com_id}`)
.then((value) => {
  console.log("companyyyyyyy ", value.data);
  setComName(value.data[0]?.companyname);
  setFormtype(value.data[0]?.type);
})
.catch((reason) => {
  console.log("reason comppppppppppp", reason.response.data);
  if (reason.response.data.includes("Token")) {
    navigate("/login");
  }
});


}, []);
const handleClearSearch = () => {
  setSearchTerm('');
  axios
  .get(`${baseUrl}/getAllSample`)
  .then((value) => {
    console.log("Form Data", value);
    setFormData(value?.data);
  })
  .catch((reason) => {
    console.log("reason", reason.response.data);
    if (reason.response.data.includes("Token")) {
      navigate("/login");
    }
  });
 
};
function survy(){
  if(formtype == 'coffees'){
    navigate('/survey1');
  }else{
    navigate('/survey2');
  }

}
const [searchTerm, setSearchTerm] = useState('');
// const handlesortclose  = ()=>{
//   setSortShow(false);
//   }  
  const handleSearch = async () => {
    try {
      if (searchTerm.trim() === '') {
        // If search term is empty, reset the search results
       setFormData(null);
        return;
      }

      const response = await axios.get(`${baseUrl}/searchAllSamples/${searchTerm}`);
     setFormData(response?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
const sortbyedit = async() =>{
  
   await axios
    .get(`${baseUrl}/form/updated_at`)
    .then((value) => {
      console.log("Form Data updated date", value.data);
      setFormData(value?.data);
      setCompanyId(value.data[0]?.companyid);
    })
    .catch((reason) => {
      console.log("reason", reason.response.data);
      if (reason.response.data.includes("Token")) {
        navigate("/login");
      }
    });
  
}
const sortbysampleid = async () =>{
  
await axios
  .get(`${baseUrl}/form/samplecoffeeid`)
  .then((value) => {
    console.log("Form Data updated date", value.data);
    setFormData(value?.data);
    setCompanyId(value.data[0]?.companyid);
  })
  .catch((reason) => {
    console.log("reason", reason.response.data);
    if (reason.response.data.includes("Token")) {
      navigate("/login");
    }
  });

}
 const sortbycreatedat = async () =>{
  
await  axios
  .get(`${baseUrl}/form`)
  .then((value) => {
    console.log("Form Data updated date", value.data);
    setFormData(value?.data);
    setCompanyId(value.data[0]?.companyid);
  })
  .catch((reason) => {
    console.log("reason", reason.response.data);
    if (reason.response.data.includes("Token")) {
      navigate("/login");
    }
  });

}
const handleDelete = (id) => {
  if (window.confirm("Are you sure you want to delete this record?")) {
    axios
      .delete(`${baseUrl}/deleteSample/${id}`)
      .then(() => {
        // setPost((prevPost) => prevPost.filter((item) => item._id !== id));
      
        alert("Record deleted successfully!");
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to delete the record.");
      });
  }
};
if (!formdata) {
  return (

    <div class="content">
    <div class='sidebar'>
      <SideBar/>
      
    </div>
    <section class = "stuff">
      <center style={{alignItems:'center'}}>
    <Rings
  height="280"
  width="280"
  color="#4fa94d"
  radius="6"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel="rings-loading"
/></center>
      </section>
    </div>
  );
}


    return(
      <><Helmet>
        <meta charSet="utf-8" />
        <title>User Dashboard | Coffee</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <div class="content">
          <div class='sidebar'>
            <SideBar />
          </div>


          <section class="stuff">

            <div class="row" style={{ padding: "20px" }}>


              <div class="col-md-11 ">

                <div class="row justify-content-between" className="display1">

                  <div class="col-md-2">
                    <div class="row add-button">
                      <Button onClick={survy} className="add-btn">New Forms<OpenInNew size={23} className="plus" /> </Button>

                    </div>
                  </div>
                  <div class="col-md-3"><h5>{compname}</h5></div>
                  <div class='col-md-5'>
        <InputGroup className="mb-3">
        <Form.Control
          placeholder="Search Froms"
          aria-label="Search"
          aria-describedby="basic-addon2"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
        <Button onClick={handleClearSearch} variant="light"><Close/></Button>)}
        <Button style={{background:'#1B5A6F'}} onClick={handleSearch} id="button-addon2">
         <Search/>
        </Button>
      </InputGroup></div>
                  <div class="col-md-2">

                    <Dropdown content="text">
                      <SplitButton className="boxshadow"

                        size="sm"
                        variant="light"
                        id="dropdown-menu-align-center"
                        title="Sort By">
                        <Dropdown.Item onClick={sortbycreatedat}>Created Date</Dropdown.Item>
                        <Dropdown.Item onClick={sortbyedit}>Last Edited</Dropdown.Item>
                        <Dropdown.Item onClick={sortbysampleid}>Number</Dropdown.Item>

                      </SplitButton>
                    </Dropdown>


                  </div>

                </div>
                <div class='mobile-view make-scrollable'>
                  <div class='row'>

                    <div class="col">Company Name</div>
                    <div class="col" style={{ marginRight: '30px' }}>
                      <DropdownButton

                        variant="transparent"
                        align={{ sm: 'end' }}
                        title={<BiFilter />}
                        flip='true'
                        id="dropdown-menu-align-responsive-1"
                      >
                        <Dropdown.Item onClick={sortbycreatedat}>Created Date</Dropdown.Item>
                        <Dropdown.Item onClick={sortbyedit}>Last Edited</Dropdown.Item>
                        <Dropdown.Item onClick={sortbysampleid}>Number</Dropdown.Item>
                      </DropdownButton>
                    </div>
                    <div style={{marginTop: 6}}>
        <InputGroup>
        <Form.Control
          placeholder="Search Froms"
          aria-label="Search"
          aria-describedby="basic-addon2"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
        <Button onClick={handleClearSearch} variant="light"><Close/></Button>)}
        <Button style={{background:'#1B5A6F'}} onClick={handleSearch} id="button-addon2">
         <Search/>
        </Button>
      </InputGroup></div>
                  </div>
                  <hr />
                  <div class="row">
                    <center style={{ marginTop: "5px" }}> <Button onClick={survy} className="add-btn">New Forms<OpenInNew size={23} className="plus" /> </Button>
                    </center>
                  </div>
                </div>

                <hr />
                <div class="soverflow">

                  {formdata.length == 0 ? <center style={{ marginTop: 100 }}><h3>No Forms ! <br /> You Can create new Form  <span type='button' onClick={survy}> heare</span></h3></center> :
                    <Row className="container" style={{ paddingLeft: "20px", paddingTop: "10px" }}>

                      {formdata.map((form) => (



                        <div className="column">

                          <div style={{ height: 120, gap: 5, }}>
                            <div style={{ width: 300, height: 120, paddingTop: 5, paddingBottom: 5, background: 'white', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', borderRadius: 16, overflow: 'hidden', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                              <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                                <div style={{ padding: 8, marginLeft: 5, borderTopLeftRadius: 12, borderTopRightRadius: 12, border: '1px #C4C4C4 solid', borderLeft: '1px #C4C4C4 solid', borderRight: '1px #C4C4C4 solid', borderBottom: '1px #C4C4C4 solid', justifyContent: 'center', alignItems: 'center', gap: 4, display: 'inline-flex' }}>
                                  <div style={{ width: 18, height: 18, position: 'relative' }}>
                                    <div style={{ width: 12, height: 12, left: 0, right: 2, top: -4, position: 'absolute', }}><FaUserCircle size={20} /></div>
                                  </div>
                                  <div style={{ color: '#232323', fontSize: 12, fontFamily: 'Poppins', fontWeight: '100', textOverflow: 'ellipsis', width: '60px', whiteSpace: 'nowrap', overflow: 'hidden' }}>{form.nameofsurveyer}</div>
                                </div>
                                <div style={{ paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 5, display: 'flex' }}>
                                  <div style={{ color: 'black', fontSize: 12.50, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word' }}>Created: {Moment(form.createdat).format('D MMM Y')}</div>
                                  <div style={{ color: 'black', fontSize: 12.50, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word' }}>Last edited: {Moment(form.updated_at).format('D MMM Y')}
                                  </div>
                                </div>
                              </div>
                              <div style={{height: 120, paddingTop: 12, paddingBottom: 16, paddingLeft: 8, paddingRight: 8, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
      <div style={{color: 'black', fontSize: 14, fontFamily: 'JetBrains Mono', fontWeight: '200',  textOverflow: 'ellipsis', width:'70px', whiteSpace: 'nowrap',overflow : 'hidden' }}>{form.samplecoffeeid?form.samplecoffeeid:"Null"}</div>
      <div style={{paddingTop: 8, paddingBottom: 8, paddingLeft: 12, paddingRight: 8, background: 'white', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
        <div style={{color: '#232323', fontSize: 11, fontFamily: 'Poppins', fontWeight: '700', wordWrap: 'break-word'}}><Trash   onClick={() => handleDelete(form.id)} color="red" type="button" size={20} /><Link  to={`/formview/${form.cfid}`}><ViewAgenda type='button' style={{marginLeft:10}} size={20} /></Link></div>
        <div style={{width: 32, height: 32, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex'}}>
          <div style={{width: 24, height: 24, position: 'relative'}}>
           <Link style={{textDecoration: 'none', color:'black'}}  to={formtype=='coffees'? '/survey1': '/survey2'}
                      state={{ data: form, anotherVariable: "1" }}> 
           <div type="button" style={{width: 24, height: 24, left: 0, top: 0, position: 'absolute',  }}><PencilSquare size={20} /></div>
         </Link> </div>
        </div>
      </div>
    </div>
                            </div>
                          </div>
                        </div>



                      ))}


                    </Row>}
                </div>



              </div>


            </div>

          </section>

        </div></>

       
    
    );
}
export default FormHome;